import agile from "assets/imgs/agile.png";
import bugs from "assets/imgs/bugs.png";
import design from "assets/imgs/design.png";
import kanban from "assets/imgs/kanban.png";
import list from "assets/imgs/list.png";
import management from "assets/imgs/management.png";
import releases from "assets/imgs/releases.png";
import roadmap from "assets/imgs/roadmap.png";
import { BoardTemplateEnum, ENUM_USER_DATE_FORMAT } from "./types";


export const projectLink = [
  { name: "Tickets", icon: "tickets", link: "boards" },
  { name: "Sprints", icon: "sprints", link: "sprints" },
  { name: "Releases", icon: "releases", link: "release" },
];

export const BOARD_TEMP_OPTIONS = [
  {
    title: "List",
    caption: "Organized & simple list of tasks",
    img: list,
    type: BoardTemplateEnum.LIST,
  },
  {
    title: "Kanban",
    caption: "Move tasks between columns",
    img: kanban,
    type: BoardTemplateEnum.KANBAN,
  },
  {
    title: "Agile Development",
    caption: "Streamline Agile workflows from backlog to completion.",
    img: agile,
    type: BoardTemplateEnum.AGILE_DEVELOPMENT,
  },
  {
    title: "Release Management",
    caption:
      "Manage software releases, CI/CD pipelines, and deployment processes.",
    img: releases,
    type: BoardTemplateEnum.RELEASE_MANAGEMENT,
  },
  {
    title: "Bug Tracking",
    caption:
      "Track and resolve bugs and issues efficiently through their lifecycle.",
    img: bugs,
    type: BoardTemplateEnum.BUG_TRACKING,
  },
  {
    title: "Design and Prototyping",
    caption: "Streamline design tasks from concept to user testing.",
    img: design,
    type: BoardTemplateEnum.DESIGN_AND_PROTOTYPING,
  },
  {
    title: "Product Roadmap",
    caption: "Plan and track feature development and product releases.",
    img: roadmap,
    type: BoardTemplateEnum.PRODUCT_ROADMAP,
  },
  {
    title: "General Project Management",
    caption: "Oversee software project from start to end.",
    img: management,
    type: BoardTemplateEnum.GENERAL_PROJECT_MANAGEMENT,
  },
];
export const DateFormatOptionsList: {
  value: ENUM_USER_DATE_FORMAT;
  label: ENUM_USER_DATE_FORMAT;
}[] = [
  {
    value: ENUM_USER_DATE_FORMAT.DD_MM_YYYY,
    label: ENUM_USER_DATE_FORMAT.DD_MM_YYYY,
  },
  {
    value: ENUM_USER_DATE_FORMAT.MM_DD_YYYY,
    label: ENUM_USER_DATE_FORMAT.MM_DD_YYYY,
  },
  {
    value: ENUM_USER_DATE_FORMAT.YYYY_MM_DD,
    label: ENUM_USER_DATE_FORMAT.YYYY_MM_DD,
  },
];
